var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.1983C21 20.1973 16.625 23.1968 11.425 24.9365C11.1527 25.0251 10.8569 25.0209 10.5875 24.9245C5.375 23.1968 1 20.1973 1 14.1983V5.79974C1 5.13755 1.56011 4.59994 2.25 4.59994C4.75 4.59994 7.875 3.16018 10.05 1.33648C10.5971 0.887839 11.4029 0.887839 11.95 1.33648C14.1375 3.17218 17.25 4.59994 19.75 4.59994C20.4399 4.59994 21 5.13755 21 5.79974V14.1983Z",
    fill: "#DDEEE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 12.698L9.4375 16.2974L16.9375 9.09864M21 14.1983C21 20.1973 16.625 23.1968 11.425 24.9365C11.1527 25.0251 10.8569 25.0209 10.5875 24.9245C5.375 23.1968 1 20.1973 1 14.1983V5.79974C1 5.13755 1.56011 4.59994 2.25 4.59994C4.75 4.59994 7.875 3.16018 10.05 1.33648C10.5971 0.887839 11.4029 0.887839 11.95 1.33648C14.1375 3.17218 17.25 4.59994 19.75 4.59994C20.4399 4.59994 21 5.13755 21 5.79974V14.1983Z",
    stroke: "#146922",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentSmall);
export default __webpack_public_path__ + "static/media/consent_small.8a0d788d119d99a9e28125fb918caedd.svg";
export { ForwardRef as ReactComponent };